<template>
  <div class="public-attached">
    <div class="box">
      <el-card class="attached">
        <div class="block">
          <self-tips title="业务附件" />
          <p></p>
          <div class="row" v-for="item in attachedList" :key="item.id">
            <div class="link-a" @click="downLoad(item)">
              <span style="background-color: #ffff00">{{
                `《${item.title}》`
              }}</span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetAttached } from "@/api/public.js";
import download from "downloadjs";
export default {
  data() {
    return {
      has: false,
      attachedList: [],
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  methods: {
    //下载操作
    downLoad(item) {
      download(item.url);
      this.$message({
        type: "success",
        message: "开始下载,请稍后",
        duration: 2500,
      });
    },
    //关闭前
    Close() {
      console.log("关闭");
    },
    //请求须知和附件
    initAxios() {
      this.getAttached();
    },
    //请求附件
    getAttached() {
      let path = this.$route.meta.path;
      GetAttached(path)
        .then((res) => {
          //   console.log(res);
          if (res.data.data.length > 0) {
            this.attachedList = res.data.data;
            this.has = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  props: {
    value: {
      type: Boolean,
    },
  },
  watch: {
    $route: {
      handler(newVal) {
        if (newVal.meta.has == true) {
          this.initAxios();
        }
      },
      deep: true,
      immediate: true,
    },
    has: {
      handler(newVal) {
        this.$emit("change", newVal);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.public-attached {
  width: 80%;
  padding: 0 40px;
  display: flex;
  align-items: center;
  margin: 0 auto;
  .box {
    width: 100%;
    .attached {
      .block {
        .row {
          display: flex;
          justify-content: center;
          margin-bottom: 15px;
          font-size: 16px;
        }
      }
    }
  }
  .attached-title {
    color: #183883;
    font-size: 18px;
  }
}
</style>